import ProductModel from '@/models/Warehouse/WhProduct'
import helper from './helpers/ProductHelper'
import { objectIsEmpty } from '@/services/JSUtils'

const baseQuery = () => {
    return ProductModel.append('sale_prices', 'stocks', 'virtual_offer_price')
        .include('sl_wholesale_discounts', 'wh_product_upc_code')
        .where('is_salable', 'true')
}

const fetch = async function() {
    const response = await ProductModel.get()
    return response
}
//const get = function(attrObject) {}
const getLike = async function(strSearch) {
    if (!strSearch) return []
    strSearch += ''
    strSearch = strSearch.toLowerCase()
    const result = await baseQuery()
        .where('search', strSearch)
        .get()
    result.data = helper.frontendProductsArray(result.data)
    return result.data
}

const get = async fieldsArray => {
    let query = baseQuery()
    fieldsArray.forEach(pair => {
        query = query.where(pair.field, pair.value)
    })
    let result = await query.get()
    return helper.frontendProductsArray(result.data)
}

/**
 * Find by Unique Key
 * @param {object} uniqueKey
 * @example
 * {
 *  field: 'database field name',
 *  value: 'unique key value'
 * }
 */
const findByKey = async uniqueKey => {
    let object = await ProductModel.where(uniqueKey.field, uniqueKey.value)
        .where('is_salable', 'true')
        .append('sale_prices', 'stocks', 'virtual_offer_price')
        .include('sl_wholesale_discounts', 'wh_product_upc_code')
        .first()
    return objectIsEmpty(object) ? null : helper.frontendProduct(object)
}

const find = async primaryKey => {
    let object = await baseQuery().find(primaryKey)
    return helper.frontendProduct(object)
}

export { fetch, get, getLike, findByKey, find, baseQuery }
